import { Defect } from "@/api/welds";
import { InspectorContext } from "../reducer";
import { InspectorRow, Probe } from "@/api/hitachi/rbi";
import { useContext } from "react";

export function useHandleFieldChanged() {
  const { state, updateState } = useContext(InspectorContext);

  function handleFieldChanged(
    rowIndex: number,
    fieldName: keyof InspectorRow,
    newValue?: string | string[] | boolean | File | Defect[] | Probe[]
  ) {
    const inspections = [...state.inspections];
    inspections[rowIndex] = { ...inspections[rowIndex], [fieldName]: newValue };
    updateState({
      type: "Inspections",
      payload: inspections,
    });
  }

  return handleFieldChanged;
}
